var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper--sidebar"},[_c('aside',{staticClass:"wrapper--sidebar__sidebar"},[_c('Sidebar',{key:_vm.key,attrs:{"isKey":_vm.isKey}})],1),_c('section',{staticClass:"wrapper--sidebar__content"},[_c('router-view',{attrs:{"isKey":_vm.isKey,"resultGlobalBreadcrumb":_vm.breadcrumb}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }